// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "@chakra-ui/react";

import { getChecklistFieldsById } from "src/reducers";
import { getFieldLabel } from "src/utils/checklist";

import { ChecklistLabel } from "../styles";
import ShowMore from "./ShowMore";
import type { FieldId, RoomId, FieldsById } from "src/types";

type Props = {
  fieldId: FieldId,
  roomId: RoomId,
};

const FieldLabel = ({ fieldId }: Props) => {
  const labelRef = useRef();
  const [showMore, setShowMore] = useState(false);
  const fieldsById: FieldsById = useSelector(({ app }) =>
    getChecklistFieldsById(app),
  );
  const details = fieldsById.get(`${fieldId}`);

  const label = getFieldLabel({
    details,
  });

  return (
    <Tooltip
      hasArrow
      label={label.length > 30 ? label : ""}
      sx={{ backgroundColor: i18n.t(k.UNIFIZE_UNIFIZEBLUE) }}
    >
      <ChecklistLabel
        data-cy={`checklist-field-label`}
        more={showMore}
        ref={labelRef}
      >
        {label}
        <ShowMore
          labelRef={labelRef}
          showMore={showMore}
          setShowMore={setShowMore}
        />
      </ChecklistLabel>
    </Tooltip>
  );
};

export default FieldLabel;
